<prt-or-plan-page [today]="today" [viewType]="viewType" />
@if (isMultiView) {
<prt-or-plan-page [today]="today" [viewType]="viewTypeLT" />
}
<prt-measures-page [today]="today" />